import React from 'react';
import PeopleStory from '../PeopleStory';

/**
 * PeopleStoryPrint — le récit de People › Synthèse, en PDF : UNE diapositive =
 * UNE page A4.
 *
 * Aucun contenu n'est réécrit ici. Le récit construit ses chapitres à un seul
 * endroit (`PeopleStory`), et son gabarit (`StoryDeck`) sait les rendre soit en
 * pile aimantée pour l'écran, soit en sections de page pour l'impression. Une
 * copie du récit aurait divergé au premier ajustement de formulation.
 *
 * Le dernier chapitre de l'écran (« Agir ») n'existe pas ici : il est apporté
 * par la page hôte en `children`, et un PDF n'a pas de boutons.
 */
export default function PeopleStoryPrint({ activeTenant, year, onDataReady }) {
  return (
    <PeopleStory
      print
      activeTenant={activeTenant}
      year={year}
      onDataReady={onDataReady}
    />
  );
}
